import $ from "jquery";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { FaCheck, FaTimes } from "react-icons/fa";

function Deolist() {
  const token = sessionStorage.getItem("secondaryAdminToken");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [deoList, setDeoList] = useState([]);
  const [showEditPassword, setShowEditPassword] = useState(false);
  const [copiedCurrent, setCopiedCurrent] = useState(false);
  const [selectedDeo, setSelectedDeo] = useState(null);
  const [mobileNo, setMobileNo] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  // Strength Labels & Colors
  const strengthLabels = ["Very Weak", "Weak", "Fair", "Good", "Strong"];
  const strengthColors = ["#e53935", "#fb8c00", "#fdd835", "#43a047", "#1e88e5"];

  // Strength Score
  const passwordStrength = {
    score:
      newPassword.length > 10
        ? 4
        : newPassword.length > 8
          ? 3
          : newPassword.length > 5
            ? 2
            : newPassword.length > 2
              ? 1
              : 0,
  };

  // Validation Rules
  const rules = [
    { valid: newPassword.length >= 8, label: "Minimum 8 characters" },
    { valid: /[A-Z]/.test(newPassword), label: "One uppercase letter" },
    { valid: /[a-z]/.test(newPassword), label: "One lowercase letter" },
    { valid: /\d/.test(newPassword), label: "One number" },
    { valid: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword), label: "One special character" },
  ];

  // Tooltip
  const renderTooltip = (props) => (
    <Tooltip id="password-tooltip"{...props} style={{ ...props.style, zIndex: 1200, }}>
      <div className="small">
        {/* Strength Bar */}
        <div className="progress mb-2" style={{ height: "6px", width: "180px" }}>
          <div
            className="progress-bar"
            style={{
              width: `${(passwordStrength.score + 1) * 20}%`,
              backgroundColor: strengthColors[passwordStrength.score],
            }}
          ></div>
        </div>

        {/* Strength Label */}
        <div
          className="mb-2"
          style={{
            color: strengthColors[passwordStrength.score],
            fontWeight: "500",
          }}
        >
          {strengthLabels[passwordStrength.score]}
        </div>

        {/* Rules List */}
        {rules.map((rule, idx) => (
          <div key={idx} style={{ color: rule.valid ? "green" : "red" }}>
            {rule.valid ? <FaCheck /> : <FaTimes />} {rule.label}
          </div>
        ))}
      </div>
    </Tooltip>
  );

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    } else {
      fetchDeoData();
    }
  }, []);

  const fetchDeoData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/FetchDEOData_CL9`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok && data.data) {
        setDeoList(data.data.deoData_list || []);
      } else {
        Swal.fire("Error", "Failed to load DEO data", "error");
      }
    } catch (error) {
      console.error("Error fetching DEO data:", error);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenEditPassword = (deo) => {
    setSelectedDeo(deo);
    setMobileNo(deo.phonE_NUMBER || "");
    setNewPassword("");
    setConfirmPassword("");
    setShowEditPassword(true);
  };

  const handleValidation = () => {
    const newErrors = {};

    // Mobile validation
    if (!mobileNo) {
      newErrors.mobileNo = "Mobile number is required";
    } else if (mobileNo.length !== 10) {
      newErrors.mobileNo = "Mobile number must be 10 digits";
    }

    /* if (!newPassword) {
      newErrors.newPassword = "New Password is required";
    } 

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required";
    } 
    
    if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Password and Confirm Password do not match";
    } */

    setErrors(newErrors);
    console.log("Validation Errors:", newErrors);
    return Object.keys(newErrors).length === 0;
  };


  /* const showConfirmToast = (onConfirm, onCancel) => {
    toast.info(
      ({ closeToast }) => (
        <div>
          <h5>Do you really want to proceed ?</h5>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginTop: "8px" }}>
            <button
              className="btn btn-sm btn-success"
              onClick={() => {
                onConfirm();
                closeToast();
              }}
            >
              Yes
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => {
                if (onCancel) onCancel();
                closeToast();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      ),
      { autoClose: false }
    );
  }; */

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!handleValidation()) return;
    /* const failedRules = rules.filter(rule => !rule.valid);
    
        if (newPassword && confirmPassword && failedRules.length > 0) {
          toast.error(
            <div>
              <strong>Password must have:</strong>
              <ul>
                {failedRules.map((r, i) => (
                  <li key={i}>{r.label}</li>
                ))}
              </ul>
            </div>
          );
          return;
        } */

    // showConfirmToast(
    //   async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${config.API_BASE_URL}/AdminUpdatePasswordNoDEOSecondary`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            deO_LOGIN_CODE: selectedDeo.logiN_ID,
            neW_PASSWORD: newPassword || selectedDeo.schooL_PASSWORD,
            neW_PH_NO: mobileNo,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        Swal.fire(
          "Success",
          `Deo ${selectedDeo.districT_NAME} updated successfully!`,
          "success"
        );
        handleCloseEditPassword();
        fetchDeoData();
      } else {
        toast.error(result.message || "Failed to update DEO");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
    //   },
    // );
  };

  const handleCloseEditPassword = () => {
    setErrors({});
    setMobileNo("");
    setNewPassword("");
    setSelectedDeo(null);
    setConfirmPassword("");
    setShowPassword(false);
    setShowEditPassword(false);
    setShowConfirmPassword(false);
  };
  const generatePassword = () => {
    const length = 10;
    const uppercase = "ABCDEFGHKMNPQRSTUVWXYZ";
    const numeric = "2345689";
    const allchars = uppercase + numeric;

    let pwd = "";
    // Ensure at least one uppercase
    pwd += uppercase.charAt(Math.floor(Math.random() * uppercase.length));
    // Ensure at least one number
    pwd += numeric.charAt(Math.floor(Math.random() * numeric.length));

    // Fill remaining with random allowed characters
    for (let i = pwd.length; i < length; i++) {
      pwd += allchars.charAt(Math.floor(Math.random() * allchars.length));
    }

    // Shuffle password
    pwd = pwd
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");

    setNewPassword(pwd);
  };


  return (
    <>
      <div className="container-scroller">
        <ToastContainer position="top-right" autoClose={3000} />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <section className="content-header">
                    <h1><i className="fa fa-user" /> DEO list</h1>
                  </section>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-4 stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-condensed table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th>Sl No.</th>
                              <th>DEO ID</th>
                              <th>District</th>
                              <th>Mobile No.</th>
                              <th style={{ width: 100 }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {deoList && deoList.length > 0 ? (
                              deoList.map((deo, index) => (
                                <tr key={deo.id}>
                                  <td>{index + 1}</td>
                                  <td>{deo.logiN_ID}</td>
                                  <td>{deo.districT_NAME} ({deo.district})</td>
                                  <td>{deo.phonE_NUMBER}</td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-info"
                                      onClick={() => handleOpenEditPassword(deo)}
                                    >
                                      <i className="fa fa-edit" /> Edit
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text-center text-muted">
                                  Data not found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      {/* Modal */}
      <AnimatePresence>
        {showEditPassword && selectedDeo && (
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              zIndex: 1100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                background: "#fff",
                borderRadius: "12px",
                width: "95%",
                maxWidth: "600px",
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <form onSubmit={handleSubmit}>
                <div
                  style={{
                    padding: "15px 30px",
                    borderBottom: "1px solid #ddd",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  <i className="fa fa-edit"></i>&nbsp;
                  Edit DEO Mobile No. & Password
                  <button
                    type="button"
                    onClick={handleCloseEditPassword}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "20px",
                      background: "transparent",
                      border: "none",
                      fontSize: "24px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    &times;
                  </button>
                </div>

                <div style={{ padding: "20px 30px" }}>
                  <div className="row">
                    {/* DEO ID */}
                    <div className="col-md-6 mb-3">
                      <label>DEO ID</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={selectedDeo.logiN_ID}
                        disabled
                      />
                    </div>

                    {/* Current Password with copy */}
                    <div className="col-md-6 mb-3">
                      <label>Current Password</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={selectedDeo.schooL_PASSWORD}
                        disabled
                      />
                    </div>

                    {/* District */}
                    <div className="col-md-6">
                      <label>District</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={selectedDeo.districT_NAME}
                        disabled
                      />
                    </div>

                    {/* New Password with eye toggle */}
                    <div className="col-md-6">
                      <label>New Password</label>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.newPassword ? "is-invalid" : ""}`}
                        value={newPassword}
                        autoComplete="new-password"
                        disabled
                      /* onChange={(e) => {
                        const newValue = e.target.value;
                        if (!newValue.includes("|")) {
                          setNewPassword(newValue);
                        }
                      }} */
                      />
                      <button type="button" className="btn btn-link  fw-bold"
                        onClick={generatePassword} style={{ textDecoration: "none" }}>
                        <i className="fa fa-magic me-1"></i> Generate Password
                      </button>
                    </div>


                    {/* Mobile No. */}
                    <div className="col-md-6">
                      <label>Mobile No.
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.mobileNo ? "is-invalid" : ""
                          }`}
                        maxLength={10}
                        value={mobileNo}
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          setMobileNo(value);
                        }}
                      />
                      {errors.mobileNo && (
                        <div className="invalid-feedback">{errors.mobileNo}</div>
                      )}
                    </div>

                  </div>
                </div>


                <div
                  style={{
                    padding: "15px 30px",
                    borderTop: "1px solid #ddd",
                    textAlign: "right",
                  }}
                >
                  <button type="submit" className="btn btn-primary btn-sm">
                    <i className="fa fa-save"></i> Submit
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence >
    </>
  );
}

export default Deolist;
